import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-64259c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "dashBoard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "대시보드", -1))
const _hoisted_3 = { class: "content-top mb20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "이용 현황", -1))
const _hoisted_5 = { class: "recent-condition mr20" }
const _hoisted_6 = {
  key: 0,
  class: "count-wrap mb20 box-shadow"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "err-server-msg",
  style: {"margin":"0 auto"}
}, "통계 정보를 조회할 수 없습니다.", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "count-wrap mb20"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "오늘 통계", -1))
const _hoisted_11 = { class: "box-shadow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "상담대기", -1))
const _hoisted_13 = { class: "today" }
const _hoisted_14 = { class: "add" }
const _hoisted_15 = { class: "box-shadow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "상담확정", -1))
const _hoisted_17 = { class: "today" }
const _hoisted_18 = { class: "add" }
const _hoisted_19 = { class: "box-shadow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "상담완료", -1))
const _hoisted_21 = { class: "today" }
const _hoisted_22 = { class: "add" }
const _hoisted_23 = { class: "box-shadow" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "접속자", -1))
const _hoisted_25 = { class: "today" }
const _hoisted_26 = { class: "add" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dash-title" }, "의료진 현황", -1))
const _hoisted_28 = {
  key: 0,
  class: "exception"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-bang" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-msg" }, "목록을 조회할 수 없습니다.", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "table"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"tr th\" data-v-64259c36><span class=\"col1 col-number\" data-v-64259c36>No.</span><span class=\"col2\" data-v-64259c36>국가</span><span class=\"col3\" data-v-64259c36>의료진</span><span class=\"col4\" data-v-64259c36>진료과목</span><span class=\"col5\" data-v-64259c36>상태</span></div>", 1)
const _hoisted_34 = { class: "td" }
const _hoisted_35 = { class: "col1 col-number" }
const _hoisted_36 = { class: "col2 txt-wrap" }
const _hoisted_37 = { class: "col3" }
const _hoisted_38 = { class: "doctor-profile" }
const _hoisted_39 = {
  key: 0,
  src: _imports_0,
  alt: "의사 프로필 사진"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "txt-wrap" }
const _hoisted_42 = {
  key: 0,
  class: "col4"
}
const _hoisted_43 = { class: "subject-list" }
const _hoisted_44 = {
  key: 0,
  style: {"padding":"0 6px 0 0"}
}
const _hoisted_45 = {
  key: 1,
  class: "col4"
}
const _hoisted_46 = { class: "col5" }
const _hoisted_47 = { class: "status-button-vue" }
const _hoisted_48 = {
  key: 2,
  class: "more"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "" }, "전체보기", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "게시판 현황", -1))
const _hoisted_52 = { class: "recent-board" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dash-title" }, [
  /*#__PURE__*/_createTextVNode("의료진 FAQ"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-lang" }, "영어")
], -1))
const _hoisted_54 = {
  key: 0,
  class: "exception"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-bang" }, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-msg" }, "목록을 조회할 수 없습니다.", -1))
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "table"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tr th hidden" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col1 col-number" }, "No."),
  /*#__PURE__*/_createElementVNode("span", { class: "col2" }, "제목")
], -1))
const _hoisted_60 = { class: "td" }
const _hoisted_61 = { class: "col1 col-number" }
const _hoisted_62 = { class: "col2 txt-el" }
const _hoisted_63 = { class: "more" }
const _hoisted_64 = {
  key: 0,
  class: ""
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dash-title" }, [
  /*#__PURE__*/_createTextVNode("의료진 공지사항"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-lang" }, "영어")
], -1))
const _hoisted_66 = {
  key: 0,
  class: "exception"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-bang" }, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "err-server-msg" }, "목록을 조회할 수 없습니다.", -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = {
  key: 1,
  class: "table"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tr th hidden" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col1 col-number" }, "No."),
  /*#__PURE__*/_createElementVNode("span", { class: "col2" }, "제목"),
  /*#__PURE__*/_createElementVNode("span", { class: "col3" }, "작성일")
], -1))
const _hoisted_72 = { class: "td" }
const _hoisted_73 = { class: "col1 col-number" }
const _hoisted_74 = { class: "col2 txt-el" }
const _hoisted_75 = { class: "col3" }
const _hoisted_76 = { class: "more" }
const _hoisted_77 = {
  key: 0,
  class: ""
}
const _hoisted_78 = { class: "content-bottom box-shadow" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dash-title" }, "상담 현황", -1))
const _hoisted_80 = { class: "appoint-wrap" }
const _hoisted_81 = {
  key: 0,
  class: "appoint-graph"
}
const _hoisted_82 = {
  key: 1,
  class: "err-server"
}
const _hoisted_83 = { class: "err-server-msg" }
const _hoisted_84 = { class: "search-calendar" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "hidden" }, "기간", -1))
const _hoisted_86 = { class: "wrap" }
const _hoisted_87 = {
  key: 0,
  class: "calendar-dim"
}
const _hoisted_88 = {
  key: 0,
  class: "currentPopup"
}

import LoadingLayer from '@/components/layer/LoadingLayer.vue';
import { onMounted, watch, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import StatusButton from '@/components/button/StatusButton.vue';
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';
import CalendarPicker from '@/components/item/CalendarPicker.vue';
import PeriodSelector from '@/components/item/PeriodSelector.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DashBoard',
  setup(__props) {

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
const store = useStore();
const router = useRouter();
const Main = store.state.moduleMain;
const exception = computed(() => Main.exception);
/**** data -------------------- */
var isOn_calendarDim = ref(false);
var todayStr = computed(() => store.getters['moduleMain/getTodayStr']);
var periodEasy = ref('00');
var dateStart = ref('');
var dateEnd = ref('');
var isReady = computed(() => Main.isReady);
var doctorApplyList = computed(() => Main.doctorApplyList);
var doctorApplyList_totalCount = computed(() => Main.doctorApplyList_totalCount);
var faqList = computed(() => Main.faqList);
var faqList_totalCount = computed(() => Main.faqList_totalCount);
var noticeList = computed(() => Main.noticeList);
var noticeList_totalCount = computed(() => Main.noticeList_totalCount);
var count = ref({
  appointWait: {
    today: computed(() => Main.appoint_waiting.today),
    add: computed(() => Main.appoint_waiting.add),
  },
  appointConfirm: {
    today: computed(() => Main.appoint_confirm.today),
    add: computed(() => Main.appoint_confirm.add),
  },
  appointComplete: {
    today: computed(() => Main.appoint_finished.today),
    add: computed(() => Main.appoint_finished.add),
  },
  visitorNumber: {
    today: computed(() => Main.visitor_count.today),
    add: computed(() => Main.visitor_count.add),
  },
});
var graph = ref({
  options: {
    responsive: true,
  },
  data: {
    loaded: false,
    labels: computed(() => Main.xVals),
    datasets: [
      {
        label: `일일 상담 건수`,
        backgroundColor: `#007575`,
        data: computed(() => Main.yVals),
      },
    ],
  },
});
/**** methods ----------------- */
const setPeriodOption = (item: { code: string; name: string }) => {
  // 간편 기간 검색 [00:전체, 01:오늘, 02:1주, 03:1달, 04:3달]
  dateEnd.value = todayStr.value;
  periodEasy.value = item.code;
  if (item.code === '00') {
    isOn_calendarDim.value = false;
  } else {
    isOn_calendarDim.value = true;
  }
  if (item.code === '00') {
    dateStart.value = '2023-01-01';
  } else if (item.code === '01') {
    dateStart.value = todayStr.value;
  } else if (item.code === '02') {
    dateStart.value = store.getters['moduleMain/getOneWeekStr'];
  } else if (item.code === '03') {
    dateStart.value = store.getters['moduleMain/getOneMonthStr'];
  } else if (item.code === '04') {
    dateStart.value = store.getters['moduleMain/getThreeMonthsStr'];
  }
};
const setDates = (start: string, end: string) => {
  dateStart.value = start; // yyyy-MM-dd
  dateEnd.value = end; // yyyy-MM-dd
};
const setCount = () => {
  store.dispatch('moduleMain/getCount', { root: true });
};
const setDoctorApplyList = async () => {
  const param = {
    page: 1,
    rows: 4,
    search_date_begin: `20230101`,
    search_date_end: todayStr.value,
    search_text: ``,
    search_type: `00`, // [00:전체, 01:의료진, 02:진료과목, 03:진료질환, 04:국가별, 05:소속 ]
  };
  await store.dispatch('moduleMain/getDoctorApply_list', param, { root: true });
};
const setFAQList = async () => {
  const param = {
    boardCategory: `112`,
    boardType: `001`,
    pageNum: 1,
    rowNum: 4,
    searchWord: ``,
  };
  await store.dispatch('moduleMain/getBoard_list', param, { root: true });
};
const setNoticeList = async () => {
  const param = {
    boardCategory: `102`,
    boardType: `000`,
    pageNum: 1,
    rowNum: 4,
    searchWord: ``,
  };
  await store.dispatch('moduleMain/getBoard_list', param, { root: true });
};
const setAppointGraph = async () => {
  const param = {
    begin_date: dateStart.value,
    end_date: dateEnd.value,
  };
  await store.dispatch('moduleMain/getAppointGraph', param, { root: true });
};
const setStartDates = async () => {
  dateStart.value = `2023-01-01`;
  dateEnd.value = todayStr.value;
};
const onClick_doctorAll = () => {
  router.push({ name: 'DoctorList' });
};
const onClick_faqAll = () => {
  router.push({ name: 'DoctorFAQ' });
};
const onClick_noticeAll = () => {
  router.push({ name: 'DoctorNotice' });
};
/**** content -----------------
 *
 * 대시보드
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  Main.isReady = false;
  (async () => {
    await (() => {
      setStartDates();
      setAppointGraph();
      setCount();
      setDoctorApplyList();
      setFAQList();
      setNoticeList();
    })();
  })();
});
watch(
  () => Main.xVals,
  async (newValue, oldValue) => {
    if (Main.appoint_graph.length === newValue.length) {
      setTimeout(() => {
        Main.isReady = true;
        graph.value.data.loaded = true;
      }, 400);
    }
  },
  { deep: true }
);
watch(
  () => Main.yVals,
  async (newValue, oldValue) => {
    if (Main.appoint_graph.length === newValue.length) {
      setTimeout(() => {
        Main.isReady = true;
        graph.value.data.loaded = true;
      }, 400);
    }
  },
  { deep: true }
);
watch(
  () => dateStart.value,
  (newValue, oldValue) => {
    graph.value.data.loaded = false;
    setAppointGraph();
  },
  { deep: true }
);
watch(
  () => dateEnd.value,
  (newValue, oldValue) => {
    graph.value.data.loaded = false;
    setAppointGraph();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("section", _hoisted_5, [
        (_unref(count).appointWait.today === undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("dl", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("dd", _hoisted_13, [
                  _createElementVNode("i", null, _toDisplayString(_unref(count).appointWait.today), 1),
                  _createTextVNode("명 ")
                ]),
                _createElementVNode("dd", _hoisted_14, _toDisplayString(_unref(count).appointWait.add), 1)
              ]),
              _createElementVNode("dl", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("dd", _hoisted_17, [
                  _createElementVNode("i", null, _toDisplayString(_unref(count).appointConfirm.today), 1),
                  _createTextVNode("명 ")
                ]),
                _createElementVNode("dd", _hoisted_18, _toDisplayString(_unref(count).appointConfirm.add), 1)
              ]),
              _createElementVNode("dl", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("dd", _hoisted_21, [
                  _createElementVNode("i", null, _toDisplayString(_unref(count).appointComplete.today), 1),
                  _createTextVNode("명 ")
                ]),
                _createElementVNode("dd", _hoisted_22, _toDisplayString(_unref(count).appointComplete.add), 1)
              ]),
              _createElementVNode("dl", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("dd", _hoisted_25, [
                  _createElementVNode("i", null, _toDisplayString(_unref(count).visitorNumber.today), 1),
                  _createTextVNode("명 ")
                ]),
                _createElementVNode("dd", _hoisted_26, _toDisplayString(_unref(count).visitorNumber.add), 1)
              ])
            ])),
        _createElementVNode("div", {
          class: "doctor-wrap box-shadow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_doctorAll()))
        }, [
          _hoisted_27,
          (_unref(doctorApplyList) === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("ul", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(doctorApplyList), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tr",
                      key: item
                    }, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(doctorApplyList_totalCount) - index), 1),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(item.nationality), 1),
                      _createElementVNode("span", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, [
                          (item.profileImageUrl === `unknown`)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: item.profileImageUrl,
                                alt: "의사 프로필 사진"
                              }, null, 8, _hoisted_40))
                        ]),
                        _createElementVNode("i", _hoisted_41, _toDisplayString(item.doctorName), 1)
                      ]),
                      (item.specialSubjects !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                            _createElementVNode("ul", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.specialSubjects, (subItem, subIndex) => {
                                return (_openBlock(), _createElementBlock("li", { key: subItem }, [
                                  _createTextVNode(_toDisplayString(subItem), 1),
                                  (item.specialSubjects.length - 1 !== subIndex)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, ","))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_45, "-")),
                      _createElementVNode("span", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(StatusButton, {
                            "status-name": item.statusName
                          }, null, 8, ["status-name"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])),
          (_unref(doctorApplyList) !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_51,
      _createElementVNode("section", _hoisted_52, [
        _createElementVNode("div", {
          class: "faq-wrap box-shadow",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_faqAll()))
        }, [
          _hoisted_53,
          (_unref(faqList) === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_57))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("ul", _hoisted_60, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqList), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tr",
                      key: item
                    }, [
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(faqList_totalCount) - index), 1),
                      _createElementVNode("span", _hoisted_62, _toDisplayString(item.title), 1)
                    ]))
                  }), 128))
                ])
              ])),
          _createElementVNode("div", _hoisted_63, [
            (_unref(faqList) !== null)
              ? (_openBlock(), _createElementBlock("button", _hoisted_64, "전체보기"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "notice-wrap box-shadow",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onClick_noticeAll()))
        }, [
          _hoisted_65,
          (_unref(noticeList) === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_69))
            : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("ul", _hoisted_72, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noticeList), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tr",
                      key: item
                    }, [
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(noticeList_totalCount) - index), 1),
                      _createElementVNode("span", _hoisted_74, _toDisplayString(item.title), 1),
                      _createElementVNode("span", _hoisted_75, _toDisplayString(item.date), 1)
                    ]))
                  }), 128))
                ])
              ])),
          _createElementVNode("div", _hoisted_76, [
            (_unref(noticeList) !== null)
              ? (_openBlock(), _createElementBlock("button", _hoisted_77, "전체보기"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_78, [
      _hoisted_79,
      _createElementVNode("section", _hoisted_80, [
        (!_unref(exception).appoint_graph.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
              (_unref(graph).data.loaded)
                ? (_openBlock(), _createBlock(_unref(Line), {
                    key: 0,
                    class: "appoint-graph-line",
                    options: _unref(graph).options,
                    data: _unref(graph).data
                  }, null, 8, ["options", "data"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(isReady) && _unref(exception).appoint_graph.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
              _createElementVNode("p", {
                class: _normalizeClass([{ 'err-server-bang': _unref(exception).appoint_graph.type === 'bang' }, { 'err-server-empty': _unref(exception).appoint_graph.type === 'empty' }])
              }, null, 2),
              _createElementVNode("p", _hoisted_83, _toDisplayString(_unref(exception).appoint_graph.desc), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_84, [
          _hoisted_85,
          _createElementVNode("div", _hoisted_86, [
            _createVNode(PeriodSelector, {
              class: "mr10 mb10",
              onSetPeriodOption: setPeriodOption
            }),
            _createVNode(CalendarPicker, { onSetDates: setDates }),
            _createVNode(_Transition, { name: "calendarDim" }, {
              default: _withCtx(() => [
                (_unref(isOn_calendarDim))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "loadingLayer" }, {
      default: _withCtx(() => [
        (!_unref(isReady))
          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
              _createVNode(LoadingLayer)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})